import React, { useState } from "react";
import { Instagram, MessageCircle, Radio, X, Check } from "lucide-react";

export const SOCIALS = [
  { key: "whatsapp", label: "Join WhatsApp Community", href: "https://chat.whatsapp.com/G6LyTzgr70RCL2dKZZyBM2", Icon: MessageCircle, cls: "btn-lime" },
  { key: "instagram", label: "Follow on Instagram", href: "https://www.instagram.com/eventom.live?igsi=NzNodXprOGVyOWJp", Icon: Instagram, cls: "btn-pink" },
  { key: "ig-channel", label: "Join Instagram Community", href: "https://www.instagram.com/channel/Aba_diwpSEgT_JF_/", Icon: Radio, cls: "btn-purple" },
];

/** Inline row of community buttons — used in the footer (so it's on every page) and on key pages. */
export function SocialRow({ size = "sm", className = "" }) {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="social-row">
      {SOCIALS.map(({ key, label, href, Icon, cls }) => (
        <a key={key} href={href} target="_blank" rel="noreferrer noopener" data-testid={`social-${key}`}
          className={`${cls} ${size === "sm" ? "!py-2 !px-3 !text-[11px]" : ""}`}>
          <Icon className="w-3.5 h-3.5" /> {label}
        </a>
      ))}
    </div>
  );
}

/** Mandatory community step shown right after signup or after submitting any partner form. */
export function SocialGate({ open, onClose, title = "You're in. Now join the crowd.", sub = "Every drop, guest list and opportunity goes out here first." }) {
  const [tapped, setTapped] = useState([]);
  if (!open) return null;
  const done = tapped.length > 0;
  return (
    <div className="fixed inset-0 z-[90] bg-black/80 backdrop-blur-md flex items-center justify-center p-4" data-testid="social-gate">
      <div className="glass w-full max-w-md p-6">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="font-display text-3xl leading-tight">{title}</div>
            <p className="text-sm text-muted mt-2">{sub}</p>
          </div>
          <button onClick={onClose} data-testid="social-gate-close" className="icon-circle !w-8 !h-8 !rounded-full shrink-0"><X className="w-4 h-4" /></button>
        </div>
        <div className="mt-5 grid gap-2">
          {SOCIALS.map(({ key, label, href, Icon, cls }) => (
            <a key={key} href={href} target="_blank" rel="noreferrer noopener"
              onClick={() => setTapped((t) => (t.includes(key) ? t : [...t, key]))}
              data-testid={`social-gate-${key}`}
              className={`${cls} w-full justify-center`}>
              {tapped.includes(key) ? <Check className="w-4 h-4" /> : <Icon className="w-4 h-4" />} {label}
            </a>
          ))}
        </div>
        <button onClick={onClose} disabled={!done} data-testid="social-gate-continue"
          className="btn-ghost w-full justify-center mt-4 disabled:opacity-40">
          {done ? "Continue →" : "Join at least one to continue"}
        </button>
      </div>
    </div>
  );
}
